import { AppError } from "../../../shared/utils/error-handler";
import type { CompanyPluginRepository } from "../../repositories/company/company-plugin-repository";
import type {
  CompanyPlugin,
  CompanyPluginConfigMap,
  CompanyPluginType,
  LiveConsultPluginConfig,
} from "../../types/company-plugin";

export class CompanyPluginUsecase {
  constructor(private companyPluginRepository: CompanyPluginRepository) {}

  async getPlugins(companyId: number): Promise<CompanyPlugin[]> {
    try {
      return await this.companyPluginRepository.getPlugins(companyId);
    } catch (error) {
      throw new AppError(
        String(error) || "연동 서비스 목록을 불러오지 못했습니다.",
        "COMPANY_PLUGIN_GET_FAILED",
        error,
      );
    }
  }

  /** 실시간 상담 플러그인만 골라 준다. 미등록이면 null */
  async getLiveConsult(
    companyId: number,
  ): Promise<LiveConsultPluginConfig | null> {
    const plugins = await this.getPlugins(companyId);
    for (const plugin of plugins) {
      // pluginType 으로 좁혀야 config 가 LiveConsultPluginConfig 로 추론된다 (find 는 좁히지 못한다)
      if (plugin.pluginType === "LIVE_CONSULT") return plugin.config;
    }
    return null;
  }

  async savePlugin<T extends CompanyPluginType>(
    companyId: number,
    pluginType: T,
    config: CompanyPluginConfigMap[T],
  ): Promise<CompanyPlugin> {
    try {
      return await this.companyPluginRepository.savePlugin(
        companyId,
        pluginType,
        config,
      );
    } catch (error) {
      throw new AppError(
        String(error) || "연동 서비스 저장에 실패했습니다.",
        "COMPANY_PLUGIN_SAVE_FAILED",
        error,
      );
    }
  }

  async deletePlugin(
    companyId: number,
    pluginType: CompanyPluginType,
  ): Promise<void> {
    try {
      await this.companyPluginRepository.deletePlugin(companyId, pluginType);
    } catch (error) {
      throw new AppError(
        String(error) || "연동 해제에 실패했습니다.",
        "COMPANY_PLUGIN_DELETE_FAILED",
        error,
      );
    }
  }
}
